import { useMutation } from '@tanstack/react-query';
import { POST, POST_INSERT_PRODUCT } from '../../../../services';
import { InsertProduct } from '../../../../resources/payload';
import { openAlert } from '../../../../components/alert/hooks';

export const useAddProduct = ({ reset }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsertProduct(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      const response = await POST(POST_INSERT_PRODUCT(), formData);
      return response.result;
    },
    onSuccess: (res) => {
      openAlert({
        model: 'message',
        type: 'success',
        message: res?.message || 'บันทึกข้อมูลสำเร็จ',
      });
      reset();
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message || 'บันทึกข้อมูลไม่สำเร็จ',
      });
    },
  });

  return { mutate, isPending };
};
